import ApiService from "../../../services/api.service";

const InventoryService = {

	getItems(data) {
		return ApiService.post(`/inventory/search`, data)
	},
	saveInventory(data) {
		return ApiService.post(`/inventory/start-partial`, data)
	},
	getDocList(payload) {
		return ApiService.post(`/inventory/list`, payload)
	},
	deleteInventoryDoc(docId) {
		return ApiService.delete(`/inventory/delete/${docId}`)
	},
	getIncomeDoc(docId) {
		return ApiService.post(`/inventory/income-document-by-inventory/${docId}`)
	},
	getWriteOffDoc(docId) {
		return ApiService.post(`/inventory/write-off-document-by-inventory/${docId}`)
	},
	getInventoryDoc(docId) {
		return ApiService.get(`/inventory/get/for-manager/${docId}`)
	},
	getInventoryItems(data, docId) {
		return ApiService.post(`/inventory/search/inventory-item/by-parent-id/${docId}`, data)
	},
	getInventoryItemsByAction(docId, action) {
		return ApiService.get(`/inventory/get/inventory-items/by-action/${docId}/${action}`)
	},
	incomesInventoryDoc(docId) {
		return ApiService.post(`/inventory/income/${docId}`)
	},
	writeOffInventoryDoc(docId) {
		return ApiService.post(`/inventory/write-off/${docId}`)
	},
	toRecount(docId, status) {
		return ApiService.put(`/inventory/finish/or/recount/${docId}/${status}`)
	}

}

export default InventoryService
